import {
  handleDeleteComment,
  handleRetrieveAllDraft,
} from "../../../redux/guest-slices/common.slice";
import { handleDeleteForum } from "../../../redux/user-slices/forum.slice";
import { checkUserType, FILE_PATH_URI } from "../../../utils/helper";
import { refresher } from "../../../redux/guest-slices/other.slice";
import SkeletonImage from "../../ui/SkeletonImage";
import TableSkell from "../../common/TableSkell";
import { useDispatch, useSelector } from "react-redux";
import { Link as NavLink } from "react-router-dom";
import Icons from "../../../assets/js/Icons";
import { useEffect, useState } from "react";

import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

function Draft() {
  const dispatch = useDispatch();
  const userType = checkUserType();
  const [data, setData] = useState({});
  const { refresh, loadings } = useSelector((state) => state.otherSlice);
  // Handle get all drafts
  const handleretrieveAll = async () => {
    const response = await dispatch(handleRetrieveAllDraft()).unwrap();
    setData(response);
  };

  // Delete functions
  const deleteActions = {
    forum: (id) => handleDeleteForum(id),
    comment: (id) => handleDeleteComment(id),
  };

  // Handle delete
  const handleDelete = async (id, type) => {
    const action = deleteActions[type];
    await dispatch(action(id));
    setTimeout(() => {
      dispatch(refresher());
    }, 500);
  };

  useEffect(() => {
    handleretrieveAll();

    // eslint-disable-next-line
  }, [refresh]);

  return (
    <Box
      sx={{
        p: 3,
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <TableContainer className="adminTable1">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["Image", "Type", "Title", "Content", "Action"]?.map(
                (cell, i) => (
                  <TableCell key={i} align="left">
                    {cell}
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {loadings?.retrieveAll ? (
              <TableSkell colLength={5} />
            ) : (
              data?.records?.map((element, i) => (
                <TableRow
                  key={i}
                  tabIndex={-1}
                  role="checkbox"
                  sx={{
                    td: {
                      borderBottomWidth:
                        i === data?.records?.length - 1 ? "0" : "1px",
                    },
                  }}
                >
                  <TableCell>
                    {element?.banner?.path ? (
                      <SkeletonImage
                        sx={{
                          width: "100%",
                          borderRadius: 1,
                          maxWidth: "200px",
                          aspectRatio: "1/0.8",
                        }}
                        src={FILE_PATH_URI + element?.banner?.path}
                      />
                    ) : (
                      "--"
                    )}
                  </TableCell>
                  <TableCell sx={{ textTransform: "capitalize" }}>
                    {element?.type === "comment"
                      ? `Comment (${element?.commentType || ""})`
                      : element?.type}
                  </TableCell>
                  <TableCell sx={{ textTransform: "capitalize" }}>
                    <Box
                      sx={{
                        maxWidth: "250px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={element?.title}
                    >
                      {element?.title || "--"}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        overflow: "hidden",
                        WebkitLineClamp: "2",
                        display: "-webkit-box",
                        textOverflow: "ellipsis",
                        WebkitBoxOrient: "vertical",
                        whiteSpace: "break-spaces",
                      }}
                      dangerouslySetInnerHTML={{ __html: element?.description }}
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      size="small"
                      sx={{ mr: 0.5 }}
                      LinkComponent={NavLink}
                      to={
                        element?.type === "forum"
                          ? `/${userType}/profile/edit-forum/${element?._id}`
                          : element?.type === "comment"
                            ? `/${userType}/profile/edit-comment/${element?._id}`
                            : null
                      }
                    >
                      <Icons.EditSolid />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => {
                        handleDelete(element?._id, element?.type);
                      }}
                    >
                      <Icons.DeleteSolid />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}

            {!data?.records?.length && !loadings?.retrieveAll && (
              <TableRow sx={{ td: { borderBottom: "none" } }}>
                <TableCell colSpan={5}>
                  <Typography variant="noRecords">No results found!</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Draft;
